import PropTypes from 'prop-types';
import { Rating, ToggleButton } from '@bwoty-web/ui-kit';

import './ratingFilter.scss';

const RatingFilter = ({
  actions,
  allBtnTotalNumberOfItems,
  filterStopsAllLabel,
  id,
  matches = {},
  options,
  selected,
}) => {
  const { clearSingleFilter, selectFilterShipRating } = actions;
  const mustShowRatings = [4, 6, 8, 10];
  const allRatings = [...new Set([...mustShowRatings, ...options])].sort((a, b) => b - a);

  const getCheckboxOption = (rating) => {
    let ratingMatches = -1;
    let ratingDisabled = false;

    if (matches !== null && typeof matches === 'object' && Object.getOwnPropertyNames(matches).length !== 0) {
      ratingMatches = matches[rating];
      ratingDisabled = !ratingMatches || ratingMatches < 1;
    }

    const ratingMatchesText = ratingMatches ? `(${ratingMatches})` : '(0)';
    return (
      <ToggleButton
        className="iw-rating-filter__option"
        key={`${id}_${rating}`}
        onChange={() => selectFilterShipRating(rating)}
        checked={selected.includes(rating)}
        disabled={ratingDisabled}
      >
        <Rating rating={rating} />
        {ratingMatchesText}
      </ToggleButton>
    );
  };

  const checkboxGroup = allRatings.map(getCheckboxOption);
  return (
    <div className="iw-rating-filter__container">
      <ToggleButton
        key={`${id}-all`}
        className="iw-rating-filter__all-option"
        checked={!selected.length}
        onChange={() => clearSingleFilter(id)}
      >
        {`${filterStopsAllLabel} (${allBtnTotalNumberOfItems})`}
      </ToggleButton>
      {checkboxGroup}
    </div>
  );
};

RatingFilter.propTypes = {
  actions: PropTypes.shape({
    clearSingleFilter: PropTypes.func,
    selectFilterShipRating: PropTypes.func,
  }).isRequired,
  allBtnTotalNumberOfItems: PropTypes.number.isRequired,
  filterStopsAllLabel: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  matches: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RatingFilter;
